module.exports = __webpack_public_path__ + "img/requisitions-icon.a5a7a9dd.svg";